const topFeaturesType = "mobile_drawer_top_feats"
const mobileFooterLinksType = "drawer_footer_links"
const leftNavDesktopLinksType = "left_nav_desktop_links"

module.exports = {
  topFeaturesType,
  mobileFooterLinksType,
  leftNavDesktopLinksType,
}
